import IPNetworks from './IPNetworks';

export const PAGE_IP_NETWORKS = '/ip-networks';

export default IPNetworks;
